import React from 'react';
import { Spin } from 'antd';

interface LoadingPageProps extends React.HTMLProps<HTMLDivElement> {}

const LoadingPage: React.FC<LoadingPageProps> = (props) => {
  return (
    <div
      {...props}
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...props.style,
      }}
    >
      <Spin size="small" />
    </div>
  );
};

export default LoadingPage;
